import React from "react";
import { HIGHLIGHT_COLORS } from "../utils/annotator/highlightColors";
import "./HighlightColorSelector.scss";

interface HighlightColorSelectorProps {
  selectedColor: string;
  onColorChange: (colorValue: string) => void;
  groupLabel?: string;
  className?: string;
}

/**
 * Radio group of highlight color dots. Built from visually-hidden native
 * radio inputs so screen readers announce a single-choice group and the
 * browser provides arrow-key selection between the dots.
 */
function HighlightColorSelector({
  selectedColor,
  onColorChange,
  groupLabel = "Highlight color",
  className,
}: HighlightColorSelectorProps) {
  return (
    <div
      role="radiogroup"
      aria-label={groupLabel}
      className={`d-flex align-items-center${className ? ` ${className}` : ""}`}
    >
      {HIGHLIGHT_COLORS.map((highlightColor) => {
        const inputId = `highlight-color-${highlightColor.label.toLowerCase()}`;
        return (
          <React.Fragment key={highlightColor.value}>
            <input
              type="radio"
              id={inputId}
              className="sr-only"
              name="highlight-color"
              value={highlightColor.value}
              checked={selectedColor === highlightColor.value}
              onChange={() => onColorChange(highlightColor.value)}
              aria-label={highlightColor.label}
            />
            <label
              htmlFor={inputId}
              className="highlightColorSelector__dotLabel mb-0 mr-2"
            >
              <HighlightColorDot colorValue={highlightColor.value} />
            </label>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default HighlightColorSelector;

export function HighlightColorDot({ colorValue }: { colorValue: string }) {
  return (
    <span
      aria-hidden="true"
      className="highlightColorSelector__dot"
      style={{ backgroundColor: colorValue }}
    />
  );
}
